const AddIcon = () => {
	return (
		<svg
			width="32"
			height="40"
			viewBox="0 0 32 40"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M14.5 32.3H17.5V25.85H24V22.85H17.5V16.35H14.5V22.85H8V25.85H14.5V32.3ZM3 40C2.2 40 1.5 39.7 0.9 39.1C0.3 38.5 0 37.8 0 37V3C0 2.2 0.3 1.5 0.9 0.9C1.5 0.3 2.2 0 3 0H21.05L32 10.95V37C32 37.8 31.7 38.5 31.1 39.1C30.5 39.7 29.8 40 29 40H3ZM19.55 12.3V3H3V37H29V12.3H19.55ZM3 3V12.3V3V37V3Z"
				fill="#64648C"
			/>
		</svg>
	);
};

export default AddIcon;
